import classNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Caret from '../components/Caret';
import UIActions from '../ui/UIActions';
import type { SidebarSectionName } from '../ui/uiReducer';
import SidebarNavItem from './SidebarNavItem';
import styles from './SidebarSection.module.scss';

interface SidebarSectionProps {
  children?: React.ReactNode;
  name: SidebarSectionName;
  title: React.ReactNode;
  icon?: React.ReactNode;
  hoverContent?: React.ReactNode;
  hidden?: boolean;
}

const SidebarSection = ({
  children,
  name,
  title,
  hoverContent,
  icon,
  hidden,
}: SidebarSectionProps) => {
  const dispatch = useAppDispatch();
  const collapsedSidebarSections = useAppSelector(
    (state) => state.ui.collapsedSidebarSections,
  );

  const isExpanded = !collapsedSidebarSections[name];

  const handleExpandClick: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(UIActions.toggleSidebarSection(name));
  };

  return (
    <div
      className={classNames(styles.container, {
        [styles.expanded]: isExpanded,
        [styles.hidden]: hidden,
      })}
      aria-label={_.startCase(name)}
    >
      <div className={styles.headerContainer}>
        <SidebarNavItem
          icon={icon}
          onClick={handleExpandClick}
          rightContent={
            <div className={styles.rightContent}>
              {!!hoverContent && (
                <div className={styles.hoverContent}>{hoverContent}</div>
              )}
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited */}
              <div
                className={styles.caretContainer}
                onClick={handleExpandClick}
              >
                <Caret direction={isExpanded ? 'up' : 'down'} size={10} />
              </div>
            </div>
          }
        >
          <div className={styles.header}>{title}</div>
        </SidebarNavItem>
      </div>
      {isExpanded && children}
    </div>
  );
};

export default SidebarSection;
